import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { fetchPracticeTypes, setTitle } from "../../actions/index";
import {
  adminCreatePracticeType,
  adminDeletePracticeType,
  adminUpdatePracticeType
} from "../../actions/admin";


//import styles
// import deleteImage from "../../../public/static/media/trash-dark58eccb99.svg";
import closeImage from "../../images/icons/close_black.svg";


@connect(store => {
  return {
    practice_types: [...store.practice_types],
    User: store.User.User,
    app: store.app
  };
})
class AdminPracticeTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openNewItem: false,
      editPracticeType: false,
      newItem: {
        practice_type: ""
      }
    };

    this.toggleNewItem = this.toggleNewItem.bind(this);
    this.handleNewItemChange = this.handleNewItemChange.bind(this);
    this.handleNewItemSubmit = this.handleNewItemSubmit.bind(this);
    this.handlePracticeTypeUpdate = this.handlePracticeTypeUpdate.bind(this);
    this.handlePracticeTypeDelete = this.handlePracticeTypeDelete.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(setTitle("Admin: Professions"));
    this.props.dispatch(fetchPracticeTypes());
  }

  handleNewItemChange(e, field) {
    let newItem = this.state.newItem;
    newItem[field] = e.target.value;
    this.setState({ newItem: newItem });
  }

  handleNewItemSubmit(e) {
    e.preventDefault();
    if(this.state.newItem.practice_type !== "" && this.state.editPracticeType == true){
      this.props.dispatch(adminUpdatePracticeType(this.state.newItem));
      this.setState({
        editPracticeType: false
      });
    }
    if (this.state.newItem.practice_type !== "" && this.state.editPracticeType == false) {
      this.props.dispatch(adminCreatePracticeType(this.state.newItem));
    }
    this.setState({
      newItem: {
        practice_type: ""
      }
    });
    this.toggleNewItem();
  }

  handlePracticeTypeUpdate(type){
    this.setState({
      editPracticeType: true,
      newItem: type
    })
    this.toggleNewItem();
  }

  handlePracticeTypeDelete(id) {
    if (confirm("Really delete this Healcare Profession?")) {
      this.props.dispatch(adminDeletePracticeType(id));
    }
  }

  toggleNewItem() {
    this.setState({ openNewItem: !this.state.openNewItem });
    if(this.state.editPracticeType == true){
      this.props.dispatch(fetchPracticeTypes());
    }
    // slide page down too
    let page = ReactDOM.findDOMNode(this.refs.page);
    let addNewItem = ReactDOM.findDOMNode(this.refs.addNewItem);
    let transform = this.state.openNewItem ? -200 : addNewItem.offsetHeight;
    page.style.transition = "0.34s transform ease-out";
    page.style.transform = `translateY(${transform}px)`;
  }

  render() {
    return (
      <main className="main adminTherapyAreas practiceTypes">
        <div
          ref="addNewItem"
          className={
            this.state.openNewItem
              ? "addItem--wrapper open"
              : "addItem--wrapper"
          }
        >
          <form onSubmit={this.handleNewItemSubmit}>
            <input
              className="md-input md-title"
              onChange={e => this.handleNewItemChange(e, "practice_type")}
              value={this.state.newItem.practice_type}
              type="text"
              placeholder="Healthcare Profession Name"
              contentEditable="true"
            />
            <p>
              <br />
              <button
                className="md-button md-raised md-primary"
                onClick={this.handleNewItemSubmit}
              >
                <span
                  className={this.state.editPracticeType ? "hide" : ""}
                >
                  Create
                </span>
                <span
                  className={!this.state.editPracticeType ? "hide" : ""}
                >
                  Update
                </span>
              </button>
            </p>
          </form>
          <a
            href="#"
            onClick={this.toggleNewItem}
            className="top-draw-handle md-button-fab"
          >
            <img
              alt="close"
              className={
                "open-close " + (this.state.openNewItem ? "close" : "")
              }
              src={closeImage}
            />
          </a>
        </div>
        <div ref="page">
          <div>
            <ul className="md-list wide practiceTypeList">
              {this.props.practice_types.map(type => (
                <li key={type._id}>
                  {type.practice_type}
                  <a
                    onClick={e => this.handlePracticeTypeUpdate(type)}
                    className="edit"
                  >
                    Edit
                  </a>
                  {/* <a
                    className="delete"
                    onClick={(e) => this.handlePracticeTypeDelete(type._id)}
                  >
                    <svg
                      width="20"
                      height="20"
                      aria-hidden="true"
                      data-prefix="far"
                      data-icon="trash-alt"
                      className="svg-inline--fa fa-trash-alt fa-w-14"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="#333"
                        d="M192 188v216c0 6.627-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12V188c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12zm100-12h-24c-6.627 0-12 5.373-12 12v216c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12V188c0-6.627-5.373-12-12-12zm132-96c13.255 0 24 10.745 24 24v12c0 6.627-5.373 12-12 12h-20v336c0 26.51-21.49 48-48 48H80c-26.51 0-48-21.49-48-48V128H12c-6.627 0-12-5.373-12-12v-12c0-13.255 10.745-24 24-24h74.411l34.018-56.696A48 48 0 0 1 173.589 0h100.823a48 48 0 0 1 41.16 23.304L349.589 80H424zm-269.611 0h139.223L276.16 50.913A6 6 0 0 0 271.015 48h-94.028a6 6 0 0 0-5.145 2.913L154.389 80zM368 128H80v330a6 6 0 0 0 6 6h276a6 6 0 0 0 6-6V128z"
                      ></path>
                    </svg>
                  </a> */}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </main>
    );
  }
}

export default AdminPracticeTypes;



// WEBPACK FOOTER //
// ./src/components/admin/AdminPracticeTypes.jsx